package com.eladfinish.bible.contest.screens.mikud.model

import androidx.compose.runtime.Immutable
import com.eladfinish.bible.contest.domain.catalog.BookData
import kotlinx.collections.immutable.ImmutableList

@Immutable
data class BookClickData(
    val bookTargetType: BookTargetType,
    val index: Int,
    val selected: Boolean,
)

@Immutable
data class ChapterClickData(
    val bookIndex: Int,
    val chapterIndex: Int,
    val selected: Boolean,
)

enum class BookTargetType {
    CHECKBOX,
    LABEL
}

enum class Selection {
    NONE,
    PARTIAL,
    ALL,
}

@Immutable
data class BookState(
    val index: Int,
    val name: String,
    val english: String,
    val chapters: ImmutableList<Boolean>,
) {
    fun isNotEmpty(): Boolean = chapters.any { it }

    val includedChaptersCount: Int = chapters.count { c -> c }

}

@Immutable
data class BookUi(
    val index: Int,
    val name: String,
    val selection: Selection,
    val totalChapters: Int,
    val selectedChapters: Int,
) {
    val isChecked = selection != Selection.NONE
}

@Immutable
data class ChapterUi(
    val index: Int,
    val name: String,
    val checked: Boolean,
)

val mikudItem = BookData(
    hebrew = "מיקוד",
    trans = "mikud",
    english = "syllabus",
    numberOfChapters = -1,
)
